import { useEffect, useState } from "react";
import { Pencil, ReplyFill } from "react-bootstrap-icons";
import { getContactName } from "@/features/chat/lib";
import {
  getLastMessagePreview,
  getFileCategory,
} from "@/shared/lib";
import { FilePreviewList } from "./files-preview";
import { MessageActionBarProps } from "./message-action-bar.props";
import { ResolvedFile, useFileLoad } from "@/shared/hooks";

export const MessageActionBar = ({
  mode,
  message,
  currentChatId,
  user,
  scrollToMessage,
  onCancel,
  onDeleteFile: onDeleteFileProp,
}: MessageActionBarProps) => {
  const fileUrls = message.fileUrls ?? [];
  const hasFiles = fileUrls.length > 0;
  const { items, loading } = useFileLoad(hasFiles ? fileUrls : null);

  const [editableItems, setEditableItems] = useState<ResolvedFile[]>([]);

  useEffect(() => {
    if (mode === "edit") {
      setEditableItems(items);
    }
  }, [items, mode]);

  if (currentChatId !== message.chat?._id) return null;

  const previewText = getLastMessagePreview(message);
  const hasAudioOnly =
    fileUrls.some((f) => getFileCategory(f) === "audio") &&
    !fileUrls.some((f) => getFileCategory(f) !== "audio");

  const handleDeleteFile = (originalUrl: string) => {
    setEditableItems((prev) =>
      prev.filter((item) => item.original !== originalUrl)
    );
    onDeleteFileProp?.(originalUrl);
  };

  const displayItems = mode === "edit" ? editableItems : items;

  return (
    <div
      style={{
        background: "#e9ecef",
        padding: "4px 12px",
        borderRadius: "8px",
        userSelect: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        fontSize: "13px",
        color: "#495057",
        position: "relative",
        marginBottom: "8px",
      }}
      onClick={() => scrollToMessage(message._id)}
      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#dee2e6")}
      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#e9ecef")}
    >
      <div
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {mode === "edit" ? (
          <div className="d-flex align-items-center">
            <Pencil fontSize={16} />
            {!hasAudioOnly && (
              <FilePreviewList
                items={displayItems}
                showDelete={true}
                onDeleteFile={handleDeleteFile}
              />
            )}
            <div className="d-flex flex-column ms-2">
              <strong>Редактирование</strong>
              <div>{hasAudioOnly ? "Аудиосообщение" : previewText}</div>
            </div>
          </div>
        ) : (
          <div className="d-flex align-items-center">
            <ReplyFill fontSize={18} />
            {!hasAudioOnly && (
              <FilePreviewList items={displayItems} showDelete={false} />
            )}
            <div className="d-flex flex-column ms-2">
              <strong>
                В ответ{" "}
                {message.owner._id === user?._id
                  ? user?.firstName
                  : ` ${getContactName(message.chat.contact)}`}
              </strong>
              <div>{hasAudioOnly ? "Аудиосообщение" : previewText}</div>
            </div>
          </div>
        )}
      </div>

      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          onCancel(currentChatId);
        }}
        style={{
          background: "none",
          border: "none",
          fontSize: "18px",
          cursor: "pointer",
          color: "#6c757d",
          padding: "0",
          marginLeft: "8px",
        }}
      >
        ×
      </button>
    </div>
  );
};
